import React, { Children, isValidElement, useMemo } from 'react';
import { Select } from 'antd';
import useIsMobile from '@/hooks/useIsMobile';
import { toSearchText } from 'utils/text';
import SelectMobile from './mobile';

const getNodeText = (node) => {
  if (typeof node === 'string' || typeof node === 'number') {
    return String(node);
  }

  if (Array.isArray(node)) {
    return node.map(getNodeText).join(' ');
  }

  if (isValidElement(node)) {
    return getNodeText(node.props?.children);
  }

  return '';
};

const normalizeOptions = (options, children) => {
  if (Array.isArray(options) && options.length) {
    return options.map((item) => ({
      ...item,
      searchText: item.searchText || toSearchText(getNodeText(item.label)),
    }));
  }

  return Children.toArray(children)
    .filter(isValidElement)
    .map((child) => ({
      label: child.props?.children,
      value: child.props?.value,
      disabled: child.props?.disabled,
      searchText: child.props?.searchText || toSearchText(getNodeText(child.props?.children)),
    }));
};

const SelectCustom = (props) => {
  const isMobile = useIsMobile(992);
  const normalizedOptions = useMemo(() => normalizeOptions(props.options, props.children), [props.options, props.children]);

  if (isMobile) {
    return <SelectMobile {...props} options={normalizedOptions} />;
  }

  return (
    <Select
      {...props}
      options={props.options || normalizedOptions}
      showSearch={props.showSearch ?? true}
      filterOption={props.filterOption || ((input, option) => {
        const inputSearchText = toSearchText(input || '');
        const optionSearchText = option?.searchText || toSearchText(getNodeText(option?.label));
        return optionSearchText.includes(inputSearchText);
      })}
    />
  );
};

export default SelectCustom;